module.exports = "/next-static/_next/static/images/block_image_personalize_branding-502d0d0f933e156b4d604a6047f4ac40.webp";